import React, { useCallback, useState } from 'react';

import useUnstakedNoundles from '../hooks/useUnstakedNoundles';
import useNoundleStakingPool from '../hooks/useNoundleStakingPool';
import ThumbnailGrid from './ThumbnailGrid';

const UnstakedNoundlesPanel = () => {
  const tokens = useUnstakedNoundles();

  const stakingPool = useNoundleStakingPool();

  const [selection, setSelection] = useState({});
  const [staking, setStaking] = useState(false);

  const stake = useCallback(async () => {
    if (stakingPool) {
      try {
        let selectedTokens = tokens.filter((tokenId) => selection[tokenId]);
        if (selectedTokens.length === 0) {
          selectedTokens = tokens;
        }

        await stakingPool.batchStake(selectedTokens).then((tx) => {
          setStaking(true);
          return tx.wait();
        });
      } catch (e) {
        if (e.code != 4001) {
          // 4001 means the user rejected the transaction in metamask
          console.log(e);
        }
      }
      setStaking(false);
    }
  }, [tokens, selection, stakingPool]);

  const selectionCount = Object.values(selection).filter((s) => s).length;
  const stakeAll = selectionCount === 0 || selectionCount === tokens.length;

  return (
    <div>
      <h2 className="mb-5">Unstaked Noundles ({tokens.length})</h2>
      <div className="py-3">
        <button
          onClick={stake}
          disabled={staking || tokens.length === 0}
          className="btn btn-lg btn-primary text-white py-3 px-5"
        >
          {staking ? (
            <span
              className="spinner-border spinner-border-sm me-2"
              role="status"
              aria-hidden="true"
            ></span>
          ) : (
            ''
          )}
          Stake {stakeAll ? 'All' : selectionCount} tokens
        </button>
      </div>
      <ThumbnailGrid tokens={tokens} onSelectionChange={setSelection} />
    </div>
  );
};

export default UnstakedNoundlesPanel;
